import { render, staticRenderFns } from "./FormTaxPph23.vue?vue&type=template&id=67b6c144"
import script from "./FormTaxPph23.vue?vue&type=script&lang=js"
export * from "./FormTaxPph23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports